import {
  TablePagination as MuiTablePagination,
  Typography,
} from "@mui/material";

const TablePagination = ({ pagination }) => {
  return (
    <MuiTablePagination
      sx={{
        "& p": {
          m: "0 !important",
        },
      }}
      SelectProps={{
        sx: { "& .MuiInputBase-input": { py: "0 !important" } },
      }}
      labelRowsPerPage={
        <Typography fontSize={13} component="span">
          Số lượng
        </Typography>
      }
      labelDisplayedRows={({ from, to, count }) => (
        <Typography fontSize={13} component="span">
          {`${from}–${to} của ${count !== -1 ? count : `nhiều hơn ${to}`}`}
        </Typography>
      )}
      rowsPerPageOptions={[20, 40, 60, 80, 100]}
      component="div"
      count={pagination.totalItems || 0}
      rowsPerPage={pagination.pageSize || 20}
      page={pagination.page - 1} // Mui 0 based-index
      onPageChange={(_e, newPage) => pagination.onPageChange(newPage + 1)}
      onRowsPerPageChange={(e) => {
        pagination.onPageSizeChange(+e.target.value);
      }}
    />
  );
};

export default TablePagination;
